import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { api, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [sent, setSent] = useState(false);
  if (user) return <Navigate to="/admin/reservas" replace />;
  const sendReset = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      nav("/admin/reservas");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAF7F2]">
      <div className="hidden lg:block relative">
        <img src="/img/cabana-real.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#1F2421]/40" />
        <p className="absolute bottom-10 left-10 font-serif text-5xl text-white">Rachel Lodge</p>
      </div>
      <div className="flex items-center justify-center p-6">
        {forgot ? (
          <form onSubmit={sendReset} className="w-full max-w-sm" data-testid="forgot-password-form">
            <p className="eyebrow">Panel privado</p>
            <h1 className="mt-2 font-serif text-4xl">Recuperar contraseña</h1>
            {sent ? (
              <p className="mt-6 text-sm leading-relaxed" data-testid="forgot-sent-message">Si el correo corresponde a la cuenta de administración, te enviamos un enlace para crear una nueva contraseña. Revisa tu bandeja de entrada y spam. El enlace dura 1 hora.</p>
            ) : (
              <div className="mt-8 space-y-4">
                <div>
                  <Label htmlFor="fem">Correo de administración</Label>
                  <Input id="fem" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-12 rounded-xl bg-white" data-testid="forgot-email-input" />
                </div>
                {err && <p className="text-sm text-red-600">{err}</p>}
                <button disabled={busy} data-testid="forgot-submit-btn" className="w-full h-12 rounded-full bg-[#5E6B52] text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
                  {busy && <Loader2 className="h-4 w-4 animate-spin" />} Enviar enlace
                </button>
              </div>
            )}
            <button type="button" onClick={() => { setForgot(false); setSent(false); }} className="mt-4 block w-full text-center text-sm text-muted-foreground hover:underline" data-testid="back-to-login-btn">Volver a ingresar</button>
          </form>
        ) : (
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <p className="eyebrow">Panel privado</p>
          <h1 className="mt-2 font-serif text-4xl">Administración</h1>
          <div className="mt-8 space-y-4">
            <div>
              <Label htmlFor="em">Correo</Label>
              <Input id="em" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-12 rounded-xl bg-white" data-testid="admin-login-email" />
            </div>
            <div>
              <Label htmlFor="pw">Contraseña</Label>
              <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 h-12 rounded-xl bg-white" data-testid="admin-login-password" />
            </div>
            {err && <p className="text-sm text-red-600" data-testid="admin-login-error">{err}</p>}
            <button disabled={busy} data-testid="admin-login-submit"
              className="w-full h-12 rounded-full bg-[#5E6B52] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[#4A5540] transition-colors disabled:opacity-60">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Ingresar
            </button>
            <button type="button" onClick={() => { setForgot(true); setErr(""); }} className="block w-full text-center text-sm font-semibold text-[#5E6B52] hover:underline" data-testid="forgot-password-link">¿Olvidaste tu contraseña?</button>
            <a href="/" className="block text-center text-sm text-muted-foreground hover:underline">Volver al sitio</a>
          </div>
        </form>
        )}
      </div>
    </div>
  );
}
